import SimpleQuestion from "./SimpleQuestion";
// import { useDispatch, useSelector } from "react-redux";
// import { getCurrentNode } from "../store/qf";

import React from "react";

const DateRange = ({ text, node, handleAnswerChange, isNodeOpen }) => {
  return (
    <SimpleQuestion
      leftString={text}
      node={node}
      rightComponent={
        <DateRangePickerLocal
          node={node}
          handleAnswerChange={handleAnswerChange}
        ></DateRangePickerLocal>
      }
    ></SimpleQuestion>
  );
};

const DateRangePickerLocal = ({ node, handleAnswerChange }) => {
  // const currentnode = useSelector(getCurrentNode);
  // const handleAnswer = (data) => {
  //   handleAnswerChange(data);
  // };
  // const dispatch = useDispatch();
  return <div>--</div>;
};

export default DateRange;
